<template>
  <div class="header">
    <NavLogo />
  </div>
</template>

<script>
import NavLogo from "@/components/nav/NavLogo";

export default {
  name: "NavTopAnon",
  components: {
    NavLogo,
  },
};
</script>

<style lang="scss">
@import "~@/styles/variables";

.header {
  height: $header-height;
}
</style>
